export default "__VITE_ASSET__ClpoyNyj__"